import { createApp } from 'vue'
import router from './router'
import App from './App.vue'
import "bootstrap/dist/css/bootstrap.css"
import scrollAnimation from './directives/animateOnScroll'

createApp(App).use(router).directive('scrollanimation', scrollAnimation).mount('#app')